module.exports = __webpack_public_path__ + "static/media/S_K.f06f2e5a.png";